(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
class CarminaSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.carmina-slideshow__slide'));
    this.dots = Array.from(this.querySelectorAll('.carmina-slideshow__dot'));
    this.track = this.querySelector('.carmina-slideshow__track');
    this.prevButton = this.querySelector('.carmina-slideshow__arrow--prev');
    this.nextButton = this.querySelector('.carmina-slideshow__arrow--next');
    this.total = this.slides.length;
    this.currentIndex = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 6) * 1000;
    this.loop = this.dataset.loop === 'true';
    this.pauseOnHover = this.dataset.pauseHover === 'true';
    this.transitionType = this.dataset.transition || 'slide';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.boundPointerDown = this.handlePointerDown.bind(this);
    this.boundPointerUp = this.handlePointerUp.bind(this);
    this.bindEvents();
    this.goTo(0);
    if (this.autoplay && this.total > 1 && !this.reducedMotion) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });
    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay && !this.reducedMotion) this.startAutoplay();
      });
    }
    this.addEventListener('pointerdown', this.boundPointerDown);
    this.addEventListener('pointerup', this.boundPointerUp);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      }
      if (event.key === 'ArrowRight') {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      }
    });
    this.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
      if (index > -1) {
        this.stopAutoplay();
        this.goTo(index);
      }
    });
    this.addEventListener('shopify:block:deselect', () => {
      if (this.autoplay && !this.reducedMotion) this.startAutoplay();
    });
  }

  handlePointerDown(event) {
    this.pointerStartX = event.clientX;
  }

  handlePointerUp(event) {
    if (typeof this.pointerStartX !== 'number') return;
    const delta = this.pointerStartX - event.clientX;
    if (Math.abs(delta) > 50) {
      if (delta > 0) {
        this.goTo(this.currentIndex + 1);
      } else {
        this.goTo(this.currentIndex - 1);
      }
      this.restartAutoplay();
    }
    this.pointerStartX = null;
  }

  goTo(index) {
    if (this.total === 0) return;
    let newIndex = index;
    if (newIndex < 0) newIndex = this.loop ? this.total - 1 : 0;
    if (newIndex >= this.total) newIndex = this.loop ? 0 : this.total - 1;
    this.currentIndex = newIndex;
    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === newIndex);
    });
    if (this.transitionType !== 'fade' && this.track) {
      this.track.style.transform = 'translateX(-' + newIndex * 100 + '%)';
    }
    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === newIndex);
    });
    if (this.prevButton) this.prevButton.disabled = !this.loop && newIndex === 0;
    if (this.nextButton) this.nextButton.disabled = !this.loop && newIndex === this.total - 1;
  }

  startAutoplay() {
    this.stopAutoplay();
    if (this.total <= 1) return;
    this.autoplayTimer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay && !this.reducedMotion) this.startAutoplay();
  }
}

if (!customElements.get('carmina-slideshow')) {
  customElements.define('carmina-slideshow', CarminaSlideshow);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
